import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';
import { leagueService } from '@/services/league';
import { useVuelidate } from '@vuelidate/core';
import { maxValue, minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useLeagueTierAdd() {
    const route = useRoute();
    const router = useAppRouter();

    const model = reactive({
        itemId: route.params.itemId,
        name: '',
        tier: 0,
        point: 0,
        imageFile: null
    });

    const validations = {
        name: { required },
        tier: { required, numeric, min: minValue(1), max: maxValue(3200) },
        point: { required, numeric, min: minValue(0), max: maxValue(3200) }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () => leagueService.tier.create(model.itemId, model.tier, model.name, model.point, model.imageFile),
        onSuccess: () => router.push({ name: ROUTE_NAME_LEAGUE.TIER.INDEX, params: { itemId: model.itemId } })
    });

    return { model, v$, create };
}
